export const filter = {
    id: "",
    name: "",
    code: "",
    parent_id:null,
    search: "",
    created_at: "",
    updated_at: "",
};
